<script>


  import './css/normalize.css';
  // import './css/sets.css'
  import './css/section.css';
  // import Nav from './wolfiex.header/Nav.svelte';
  import Header from './wolfiex.header/Header.svelte';
  import ActivityCell from './ActivityCell.svelte';
  import HireCell from './HireCell.svelte';
  import Quals from './Quals.svelte';

  import Cell from './Cell.svelte';
  import Insta from './Insta.svelte';
  // import Header from './Header.svelte';


  import Video from './Video.svelte';
  import {onMount} from 'svelte';

//   let domReady = () => {
//   return new Promise((resolve, reject) => {
//     (document.readyState) || reject("Can't resolve document readystate");
//     let listener;
//     (/d$|^i|^c/).test(document.readyState) ? resolve() : document.addEventListener("DOMContentLoaded", listener = event => {
//       document.removeEventListener("DOMContentLoaded", listener);
//       resolve();
//     });
//   });
// }


function ready() {
			return new Promise( function(resolve) {
				document.addEventListener('readystatechange', function() {
					console.log(rfn)
					if(document.readyState != 'loading' && document.readyState != 'interactive')
						resolve();
				});
			});

		};
  
  let domReady = ready()


  // import * from

  onMount(() => {
    var el = document.getElementById('name');
    el.innerText = el.textContent =
      '[]{[--]}  d|2a|1n|3i|2e|2l|1 |1e|2l|0l|3i|1[++]s|1 '; //'     [ ....[adventure]]'

  });
  
</script>

<main>
  <body id="top">
    <header id="home">
      <!-- <Nav /> -->

      <Header style="active">
        <section class="hero" id="hero">
          <div class="container">
            <div class="row">
              <div class="col-md-8 col-md-offset-2 text-center inner">
                <h1 class="animated fadeInDown dlg" id="name">
                  Daniel Ellis Adventure
                </h1>
                <p class="animated fadeInUp delay-05s">
                  <em>Adventure, Instructing, and Performance Coaching</em>
                </p>
              </div>
            </div>

            <!-- <div class="row">
              <div class="col-md-6 col-md-offset-3 text-center">
                <a
                  href="http://contact.danielellisresearch.com"
                  class="learn-more-btn">BOOK / HIRE</a
                >
              </div>
            </div> -->
          </div>
        </section>
      </Header>
    </header>
    <section class="intro text-center section-padding" id="intro">
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-md-offset-2 wp1">
            <h1 class="arrow">Background</h1>
            <p>

              I am an outdoor coach and leader with over 20 years of experience in a <a href='#talk'>range of activities</a> and environments, including competition at a national level.

              <br /><br />
              
              
              Coupling this with my background in <a href="https://danielellisresearch.com">data analytics, microcontroller design and
              programming skills </a> allows for the building and design of bespoke perfomance
              tracking tools in a range of 'extreme' conditions.
              <br /><br />

              <!--               
              <a href="#"
                >consequat ut sed sem</a
              >. -->
            </p>
          </div>
        </div>
      </div>
    </section>

    <HireCell />
    <section class="swag text-center">
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-md-offset-2">
            <h2>
              <it
                ><em>"Love what you do</em>,<span>
                  and you'll do it well</span
                >"</it
              >
            </h2>
            <a href="#portfolio" class="down-arrow-btn"
              ><i class="fa fa-chevron-down" /></a
            >
          </div>
        </div>
      </div>
    </section>
    <Quals />

    <section class="text-center" id="responsive">
      <div class="container-fluid nopadding responsive-services">
        <div class="wrapper">
          <div class="iphone">
            <div class="wp3" />
          </div>
          <div class="fluid-white" />
        </div>
        <div class="container designs" style="margin:auto">
          <!-- <div class="row"> -->
          <div class="col-md-8 col-md-offset-6 vid">
            <p>A selection of videos from past projects</p>
            {#await domReady}
            <Video width="100%" height="100%" />
            {/await}
            <!-- </div> -->
          </div>
        </div>
      </div>
    </section>
    <section class="swag text-center">
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-md-offset-2">
            <h1>I got 99 Problems<span>but <em>the outdoors</em> 'aint one</span></h1>
            <a href="#portfolio" class="down-arrow-btn"
              ><i class="fa fa-chevron-down" /></a
            >
          </div>
        </div>
      </div>
    </section>
{#await domReady}
<ActivityCell/>
{/await}


    <!-- <div class="ignite-cta text-center">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <a href="#" class="ignite-btn">Ignite Your Passion</a>
          </div>
        </div>
      </div>
    </div> -->

    <section class="subscribe text-center">
      {#await domReady}
        
      <Insta/>
        
      {/await}
      
<br><br>
      <a href='https://www.instagram.com/dan.ellis.adventure/'>
      <!-- <div class="container"> -->
        
        <h2 style="color:#111;backdrop-filter: blur(10px);" >
          <i class="fa fa-paper-plane" /><br>
         <span style="font-size:medium;"
            >Subscribe to stay in the loop</span
          >
        </h2>
        <!-- <form action="#">
          <input type="text" name="" value="" placeholder="" required />
          <input type="submit" name="" value="Send" />
        </form> -->
      <!-- </div> -->
    </a>
    </section>


    <section
      class="dark-bg text-center section-padding contact-wrap"
      id="contact"
    >
      <a href="#top" class="up-btn"><i class="fa fa-chevron-up" /></a>
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1 class="arrow">Drop us a line</h1>
          </div>
        </div>
        <div class="row contact-details">
          <div class="col-md-4">
            <div class="light-box box-hover">
              <h2><i class="fa fa-map-marker" /><span>Email</span></h2>
              <p>adventure<it>@</it>danielellisresearch<it>.com</it></p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="light-box box-hover">
              <h2><i class="fa fa-mobile" /><span>Instagram</span></h2>
              <p>dan.ellis.adventure</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="light-box box-hover">
              <h2><i class="fa fa-paper-plane" /><span>Twitter</span></h2>
              <p>danielellisscience</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <ul class="social-buttons">
              <li>
                <a href="#" class="social-btn"><i class="fa fa-dribbble" /></a>
              </li>
              <li>
                <a href="#" class="social-btn"><i class="fa fa-twitter" /></a>
              </li>
              <li>
                <a href="#" class="social-btn"><i class="fa fa-envelope" /></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  </body>
</main>

<style>
  @font-face {
    font-family: 'Datalegreya-Dot';
    src: url('/Datalegreya-Dot.otf');
    font-weight: normal;
    font-style: normal;
  }

  :root{
    --coral--invert:rgb(4, 183, 240);
    --link-blue:#78a9ff;
    --link-green:rgba(61, 201, 179, 0.8);
  }

  .hero {
    padding: 65px 0 100px 0 !important;
  }

  .dlg {
    font-family: Datalegreya-Dot !important;
    /* font-size: 130%; */
    -webkit-font-feature-settings: 'kern' on, 'liga' on, 'calt' on;
    -moz-font-feature-settings: 'kern' on, 'liga' on, 'calt' on;
    -webkit-font-feature-settings: 'kern' on, 'liga' on, 'calt' on;
    -ms-font-feature-settings: 'kern' on, 'liga' on, 'calt' on;
    font-feature-settings: 'kern' on, 'liga' on, 'calt' on;
    font-variant-ligatures: common-ligatures discretionary-ligatures contextual;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    color: var(--link-green);
    letter-spacing: 1px;
    font-size: 600%;
    /* -moz-osx-font-smoothing: grayscale; */
  }

  :global(.arrow) {
    color: var(--link-green) !important;
  }

  :global(.wp3){
    background-position:0;
  }

</style>
